import { pr, ui } from "aaa";
import { themeColors } from "muiTheme";
import * as React from "react";

export const SigningMethodBanner = ({ children }: { children: React.ReactNode }) => (
    <div
        style={{
            alignItems: "center",
            textAlign: "center",
            borderRadius: 8,
            padding: "12px 16px",
            backgroundColor: ui.isDarkMode ? themeColors.d_blue_100 : themeColors.blue_300
        }}
    >
        <pr.P_14_CONTENT style={{ color: "white" }}>
            {children}
        </pr.P_14_CONTENT>
    </div>
);


// WEBPACK FOOTER //
// ./src/components/loginManagement/components/SigningMethodBanner.tsx